import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ownerApi, errText } from "@/lib/ownerApi";

export default function Account() {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const save = async (e) => {
    e.preventDefault();
    try { await ownerApi.post("/change-password", { current_password: cur, new_password: nw }); toast.success("Password changed"); setCur(""); setNw(""); }
    catch (er) { toast.error(errText(er)); }
  };
  return (
    <form onSubmit={save} className="max-w-sm rounded-2xl border border-stone-200 bg-white p-5 space-y-3" data-testid="owner-account">
      <h3 className="font-bold text-stone-900">Change password</h3>
      <Input type="password" placeholder="Current password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="owner-pw-current" required />
      <Input type="password" placeholder="New password (8+ characters)" value={nw} onChange={(e) => setNw(e.target.value)} data-testid="owner-pw-new" required />
      <Button type="submit" className="bg-emerald-800 hover:bg-emerald-900" data-testid="owner-pw-save">Update password</Button>
    </form>
  );
}
